export enum ProductPositionFormTabType {
  GENERAL = "GENERAL",
  REMARK = "REMARK",
  CLARIFICATION_REQUEST = "CLARIFICATION_REQUEST",
  CONFIGURATION = "CONFIGURATION",
  TENDER_TEXT = "TENDER_TEXT",
  DIMENSIONING = "DIMENSIONING",
  ADDONS = "ADDONS",
  INSTALLATION_REFERENCES = "INSTALLATION_REFERENCES",
  DOWNLOADS = "DOWNLOADS",
  ATTACHMENTS = "ATTACHMENTS"
}
